import { HomeIcon } from '@heroicons/react/24/outline';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '@hooks/useAuth';
import { ROUTES } from '@lib/routes';
import { UserRole } from '@shared/types/user';

export function AdminShortcut(): JSX.Element | null {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isAdmin = user?.role === UserRole.ADMIN;
  const isOnAdminRoute =
    location.pathname === ROUTES.ADMIN.BASE || location.pathname.startsWith(`${ROUTES.ADMIN.BASE}/`);

  if (!isAdmin || isOnAdminRoute) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate(ROUTES.ADMIN.DASHBOARD)}
      className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 rounded-full border border-white/10 bg-gray-900/90 px-4 py-2 text-sm font-semibold text-white shadow-2xl shadow-gray-900/40 backdrop-blur transition hover:bg-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
      aria-label="Return to admin dashboard"
      title="Return to admin dashboard"
    >
      <HomeIcon className="h-4 w-4" aria-hidden="true" />
      Admin Dashboard
    </button>
  );
}


